import { useEffect, useState } from 'react';
import { resolveImage } from "../../images/ImageResolver";
import WealthPackages from './WealthPackages';
import { fetchData, textWithIcon, styles } from './Helpers';

function transformData(data){
  let tData = data.map(row => ({
    name: row.data_items.replace(/\|/g, "") + "|" + row.description.replace(/\|/g, "") + "|" + row.endpoints,
    public: row.public,
    private: row.private,
    advanced: row.advanced,
    professional: row.professional,
  }))
  return tData
}

function EntityRef() {
  const [wealth, setWealth] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.name.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Entity_Reference").then((res) => {
      setFullData(transformData(res));
      setLoading(false);
    });
  }, []);
  
  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'ITEM', field: 'name', width: 4, scalable: true, binding: cellWithMultipleLines },
      { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), binding: textWithIcon, styles: styles },
      { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: textWithIcon },
      { name: 'ADVANCED', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "advanced"), binding: textWithIcon, styles: styles },
      { name: 'PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "professional"), binding: textWithIcon }
    ]

    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("div");
        firstLine.style.fontWeight = "600";
        content._firstLine = firstLine;
        content.appendChild(firstLine);

        let secondLine = document.createElement("div");
        secondLine.style.fontWeight = "400";
        secondLine.style.color = "#666666";
        secondLine.style.maxHeight = "75px";
        secondLine.style.overflow = "hidden";
        secondLine.style.textOverflow = "ellipsis";
        secondLine.style.whiteSpace = "nowrap";
        secondLine.style.wordWrap = "break-word";
        secondLine.style.whiteSpace = "normal";
        content._secondLine = secondLine;
        content.appendChild(secondLine);
        
        let thirdLine = document.createElement("div");
        thirdLine.style.fontWeight = "400";
        thirdLine.style.color = "blue";
        content._thirdLine = thirdLine;
        content.appendChild(thirdLine);
      }
      let rowData = e.data.split('|');
      content._firstLine.textContent = rowData[0];
      content._secondLine.textContent = rowData[1];
      content._secondLine.title = rowData[1];
      content._thirdLine.textContent = "Endpoint: "+rowData[2];
      cell.setContent(content);
    }

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };
    
    if(!wealth){
      grid.config = {
        rowHeight: 120,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: searchData.length > 0 ? searchData : fullData
        }
      }; 
    }
  }, [fullData, searchData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <div id='loadingMask_div'>
          <h4>Segmentation for entity reference content in company snapshot API</h4>
          <p>Clients may subscribe for regional or global packages. Clients are responsible for limiting their use of content to the regions they are licensed for and the segmentation for Entitiy Reference Data fields as outlined in this data guide.</p>
          <ef-layout flex style={{ marginTop: '20px' }}>
            <ef-layout>
              <input
                className='search-field'
                type="text"
                placeholder="Type to search..."
                onChange={(e) => searchEvent(e.target.value)}
              />
            </ef-layout>
          </ef-layout>
          <efx-grid id="grid" className="entity-grid"></efx-grid>
        </div>
      )}
    </div>
  );
}

export default EntityRef;
